import MySuccessView from 'components/views/MySuccess';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators, getLevel, getPoints } from 'store/mySuccess';

const mapStateToProps = (state) => ({
	hasDataInState: ((points: null | number, level: null | string) => {
		return !!(points && level);
	})(getPoints(state), getLevel(state)),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doRequestMySuccess: actionCreators.doRequestMySuccess,
			doRequestMySuccessLevels: actionCreators.doRequestMySuccessLevels,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(MySuccessView as any);
